"use client";

import type { ChangeEvent } from "react";
import { useState } from "react";
import { InputText } from "../input-text";
import { PairedButton } from "../paired-button";

type SearchBlockInteractiveProperties = {
  /** The placeholder text for the search input. */
  placeholder?: string | undefined;
  /** The href for the search block. */
  href: string;
  /** The target for the search block. */
  target?: "_blank" | "_self" | undefined;
  /** The theme for the search block. */
  theme?: "light" | "dark" | undefined;
};

/**
 * Client Component: Handles user input and interactivity.
 */
export const SearchBlockInteractive = ({
  placeholder = "",
  href = "",
  target = "_self",
  theme = "light",
}: SearchBlockInteractiveProperties) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <div className="bottom-1 flex w-full justify-center">
      <div className="flex w-full max-w-[468px]">
        <InputText
          label={placeholder}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setSearchValue(event.target.value);
          }}
          value={searchValue}
        />
        <PairedButton
          aria-label="Search"
          as="a"
          href={`${href}?search=${encodeURIComponent(searchValue)}`}
          target={target}
          variant={theme === "dark" ? "secondary" : "primary"}
        />
      </div>
    </div>
  );
};

SearchBlockInteractive.displayName = "SearchBlock.Interactive";
